import { useTranslation } from "react-i18next";
import { useOrientation, useWindowSize } from "react-use";
import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";

import { LARUCHE_IDENTIFIER } from "@constants/index";

import { useTelemetryStore } from "@hooks/store/useTelemetryStore";


export const useSubmitTelemetry = () => {
  const store = useTelemetryStore();
  const { i18n } = useTranslation();
  const { width, height } = useWindowSize();
  const { type: orientation } = useOrientation();

  // const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: () => {
      return api.post("telemetry/", {
        user_id: store.userId,
        timestamp: store.timestamp,
        idle_time: store.idleTime,
        idle_warning_count: store.idleWarningCount,
        idle_signout_count: store.idleSignOutCount,
        total_time_spent: store.totalTimeSpent,
        language: store.language,
        os: store.os,
        browser: store.browser,
        screen_resolution: store.screenResolution,
        screen_orientation: store.screenOrientation,
        sign_in_attempts: store.signInAttempts,
      });
    },
    onSuccess: () => {
      import.meta.env.DEV &&
        console.log("[Telemetry] - Submitted successfully");

      const userStore = sessionStorage.getItem(
        `${LARUCHE_IDENTIFIER}-user-store`
      );
      const parsedUserStore = JSON.parse(userStore || "{}");
      const isUserSignedIn = parsedUserStore?.state?.user?.isUserSignedIn;
      const userId = parsedUserStore?.state?.user?.id;

      store.resetTelemetry();
      store.setTimestamp(new Date().toISOString());

      if (!isUserSignedIn) {
        import.meta.env.DEV &&
          console.log("[Telemetry] - User not signed in, resetting...");
        return;
      } else {
        import.meta.env.DEV &&
          console.log(
            "[Telemetry] - User still signed in, reset but preserving userId"
          );
        store.setLanguage(i18n.language);
        store.setScreenOrientation(orientation);
        store.setScreenResolution(`${width}x${height}`);
        store.setUserId(userId);
      }
    },

    onError: (res: any) => {
      console.error("[From Submit Telemetry]", res);

      // handleErrors(res, "mutation");
    },
  });
};
